import { Formik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Label, Row } from "reactstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";
import axios from "axios";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import { AlertPopups } from "../../../components/AlertPopups";
import { UserConsumer } from "../../../UserContext";

function CMApprovalForm(props) {
	const { itemRequisitionId, disableForm } = props;
	let token = null;
	const initialValues = {
		cmApprovalStatus: "",
		cmComments: "",
	};
	const [formFields, setFormFields] = useState(initialValues);

	useEffect(() => {
		axios
			.get(
				`${ItemRequisitionAPI.GetApproval}/${itemRequisitionId}/CMApproval`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ status, data }) => {
				if (status === 200) {
					const approvalStatus = statusList.find(
						(item) => item.value === data.cmApprovalStatus
					);
					setFormFields({
						cmApprovalStatus: approvalStatus,
						cmComments: data.cmComments,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	}, []);

	const validate = Yup.object().shape({
		cmApprovalStatus: Yup.string()
			.required("Select Status")
			.typeError("Invalid input")
			.nullable(),
		cmComments: Yup.string()
			.required("comments is required")
			.typeError("Invalid input"),
	});
	const statusList = [
		{ value: 0, label: "Pending" },
		{ value: 1, label: "Approve" },
		{ value: 2, label: "Reject" },
	];
	const handleSubmit = () => {
		const requestBody = {
			cmApprovalStatus: formFields.cmApprovalStatus.value,
			cmComments: formFields.cmComments,
		};
		axios
			.put(
				`${ItemRequisitionAPI.PostApproval}/${itemRequisitionId}/CMApproval`,
				requestBody,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then(({ status, message }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Status Updated",
					});

					window.location.reload();
				} else if (status === 400) {
					AlertPopups.ErrorAlert.fire({
						text: message,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<>
						{disableForm ? (
							<div
								className="pt-5 formInfoContainer"
								style={{ backgroundColor: "white" }}
							>
								<div className="formInfoContainer">
									<div className="formInfoContainerHeader">
										<Label sm={8}>CM Approval</Label>
									</div>
									<Formik
										enableReinitialize={true}
										initialValues={formFields}
										validationSchema={validate}
										validateOnChange={true}
										onSubmit={() => handleSubmit()}
									>
										{({ errors, handleSubmit }) => (
											<Form>
												<Row className="py-2 px-4">
													<Col md={12} lg={3}>
														<div className="formDetailHeader">
															<div>Comments</div>
														</div>
													</Col>
													<Col
														md={12}
														lg={3}
														className="my-1"
													>
														<Input
															type="textarea"
															name="supervisorComments"
															className={`formValueInput ${
																errors.cmComments
																	? "h-auto invalid"
																	: "h-auto"
															}`}
															onChange={(event) =>
																setFormFields({
																	...formFields,
																	cmComments:
																		event
																			.target
																			.value,
																})
															}
															disabled={true}
															readOnly={true}
															value={
																formFields.cmComments
															}
															maxLength="400"
														/>
													</Col>
												</Row>
											</Form>
										)}
									</Formik>
								</div>
							</div>
						) : (
							<div
								className="pt-5 mb-5 formInfoContainer"
								style={{ backgroundColor: "white" }}
							>
								<div className="formInfoContainer">
									<div className="formInfoContainerHeader">
										<Label sm={8}>CM Approval</Label>
									</div>
									<Formik
										enableReinitialize={true}
										initialValues={formFields}
										validationSchema={validate}
										validateOnChange={true}
										onSubmit={() => handleSubmit()}
									>
										{({ errors, handleSubmit }) => (
											<Form>
												<Row className="py-2 px-4">
													<Col md={12} lg={3}>
														<div className="formDetailHeader">
															<div>
																CM Approval
																Status
															</div>
														</div>
													</Col>
													<Col md={12} lg={3}>
														<CustomReactSelect
															options={statusList}
															value={
																formFields.cmApprovalStatus
															}
															onChange={(value) =>
																setFormFields({
																	...formFields,
																	cmApprovalStatus:
																		value,
																})
															}
															className={`formValueInput description ${
																errors.cmApprovalStatus
																	? "h-auto invalid"
																	: "h-auto"
															}`}
														/>
													</Col>

													<Col md={12} lg={3}>
														<div className="formDetailHeader">
															<div>Comments</div>
														</div>
													</Col>
													<Col
														md={12}
														lg={3}
														className="my-1"
													>
														<Input
															type="textarea"
															name="supervisorComments"
															className={`formValueInput ${
																errors.cmComments
																	? "h-auto invalid"
																	: "h-auto"
															}`}
															onChange={(event) =>
																setFormFields({
																	...formFields,
																	cmComments:
																		event
																			.target
																			.value,
																})
															}
															value={
																formFields.cmComments
															}
															maxLength="400"
														/>
													</Col>
												</Row>
												<div className="btns">
													<Button
														className="submit-btn leftBtn"
														onClick={handleSubmit}
													>
														Submit
													</Button>
												</div>
											</Form>
										)}
									</Formik>
								</div>
							</div>
						)}
					</>
				);
			}}
		</UserConsumer>
	);
}

export default CMApprovalForm;
